import _slicedToArray from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { TextInput as k, Button as v } from "@box/blueprint-web";
import { useState as b, useRef as E, useCallback as r, useEffect as x } from "react";
import { useIntl as L } from "react-intl";
import { usePropSyncedState as w } from "../hooks/usePropSyncedState.js";
import { s as n } from "../../../chunks/hyperlink-popover.module.js";
import { messages as s } from "../messages.js";
import { tryPrependProtocol as m } from "../utils/protocoled-url.js";
import { jsxs as C, jsx as l } from "react/jsx-runtime";

var I = function I(_ref) {
  var f = _ref.initialUrl,
      i = _ref.onSubmit;

  var a = L(),
      _w = w(f),
      _w2 = _slicedToArray(_w, 2),
      t = _w2[0],
      p = _w2[1],
      _b = b(!1),
      _b2 = _slicedToArray(_b, 2),
      d = _b2[0],
      h = _b2[1],
      u = E(null),
      c = r(function (e) {
    try {
      new URL(m(e));
    } catch (_unused) {
      return h(!0), !1;
    }

    return !0;
  }, []),
      o = r(function () {
    c(t) && i(m(t));
  }, [i, c, t]),
      y = r(function (e) {
    e.key === "Enter" && (e.preventDefault(), o());
  }, [o]),
      g = r(function (e) {
    return p(e.target.value);
  }, []);

  return x(function () {
    var e;
    (e = u.current) == null || e.focus();
  }, []), /* @__PURE__ */C("div", {
    className: n.writeState,
    children: [/* @__PURE__ */l("div", {
      className: n.editableLinkWithError,
      children: /* @__PURE__ */l(k, {
        ref: u,
        autoFocus: !0,
        className: n.editableLink,
        "data-testid": "edit-hyperlink-input",
        error: d && a.formatMessage(s.invalidUrlError),
        hideLabel: !0,
        label: "",
        onChange: g,
        onKeyDown: y,
        type: "text",
        value: t
      })
    }), /* @__PURE__ */l(v, {
      "aria-label": a.formatMessage(s.applyButton),
      onClick: o,
      variant: "tertiary",
      children: a.formatMessage(s.applyButton)
    })]
  });
};

export { I as EditLink };